module.exports = __webpack_public_path__ + "static/assets/4fbcf2c035110247216ce61d5f7429fc.png";